import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import elementVariables from '@/styles/element-variables.scss';
import defaultSettings from '@/settings';
var Settings = /*#__PURE__*/function (_VuexModule) {
  function Settings() {
    var _this;
    _classCallCheck(this, Settings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Settings, [].concat(args));
    _defineProperty(_this, "theme", elementVariables.theme);
    _defineProperty(_this, "fixedHeader", defaultSettings.fixedHeader);
    _defineProperty(_this, "showSettings", defaultSettings.showSettings);
    _defineProperty(_this, "showTagsView", defaultSettings.showTagsView);
    _defineProperty(_this, "showSidebarLogo", defaultSettings.showSidebarLogo);
    _defineProperty(_this, "sidebarTextTheme", defaultSettings.sidebarTextTheme);
    return _this;
  }
  _inherits(Settings, _VuexModule);
  return _createClass(Settings, [{
    key: "CHANGE_SETTING",
    value: function CHANGE_SETTING(payload) {
      var key = payload.key,
        value = payload.value;
      if (Object.prototype.hasOwnProperty.call(this, key)) {
        this[key] = value;
      }
    }
  }, {
    key: "ChangeSetting",
    value: function ChangeSetting(payload) {
      this.CHANGE_SETTING(payload);
    }
  }]);
}(VuexModule);
__decorate([Mutation], Settings.prototype, "CHANGE_SETTING", null);
__decorate([Action], Settings.prototype, "ChangeSetting", null);
Settings = __decorate([Module({
  dynamic: true,
  store: store,
  name: 'settings'
})], Settings);
export var SettingsModule = getModule(Settings);